import { RouterProvider } from "react-router-dom";
import { protectedRoutes } from "./protectedRoutes";
import { publicRoutes } from "./publicRoutes";
import { useSelector } from "react-redux";
import { getLoggedInUser } from "@root/store/selectors/entities";

const Router = () => {
  const isLoggedInUser: any = useSelector(getLoggedInUser);

  // Signed-in users get the app; everyone else gets the login/public pages.
  // (Users have no roleId on this backend, so presence of the user is the check.)
  return (
    <RouterProvider router={isLoggedInUser ? protectedRoutes : publicRoutes} />
  );
};

export default Router;
